import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type {
  SummaryGraphParameters,
  SummaryGraphResponse,
  SummaryTableParameters,
  SummaryTableResponse,
} from './summary-api';

const BASE_URL = `${config.apiHost}/merchant-portal/api/v1/public/dashboard/summary`;

export async function getGraphData(
  params: SummaryGraphParameters
): Promise<SummaryGraphResponse> {
  const res = await makeRequest<{ payload: SummaryGraphResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/graph`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}

export async function getTableDataByMerchant(
  params: SummaryTableParameters
): Promise<SummaryTableResponse> {
  const res = await makeRequest<{ payload: SummaryTableResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/by-merchant`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}

export async function getTableDataByPos(
  params: SummaryTableParameters
): Promise<SummaryTableResponse> {
  const res = await makeRequest<{ payload: SummaryTableResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/by-point-of-sales`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}
